import postWithToken from './base/post-with-token'

const updateCustomerSiteContact = (id, urlDetailCustomer) => postWithToken(`/customer-contact/${id}?type=${urlDetailCustomer}`)

export default updateCustomerSiteContact